var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("FormBuilder", {
        attrs: { formData: _vm.formData, formValue: _vm.formValue },
      }),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "modalCopyVisitSchedule",
          attrs: { title: "Copy visit schedule", formValue: _vm.formValue },
        },
        [
          _c("div", { staticClass: "close" }),
          _vm._v(" "),
          _c("i", [
            _vm._v(
              "Warning, you cannot undo this copying, so please be careful about selecting treatment groups."
            ),
          ]),
          _vm._v(" "),
          _c("form", { on: { submit: _vm.onCopyVisitScheduleSubmit } }, [
            _c("div", { staticClass: "input", attrs: { type: "select" } }, [
              _c("label", [
                _c("span", [_vm._v("Select treatmentgroup from")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.copyDispensingScheduleFromTreatmentGroupId,
                        expression:
                          "copyDispensingScheduleFromTreatmentGroupId",
                      },
                    ],
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.copyDispensingScheduleFromTreatmentGroupId = $event
                          .target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c(
                      "option",
                      { attrs: { value: "", disabled: "", selected: "" } },
                      [_vm._v("Select treatment group")]
                    ),
                    _vm._v(" "),
                    _vm._l(
                      _vm.formValue.treatmentGroups,
                      function (treatmentGroup) {
                        return _c(
                          "option",
                          { domProps: { value: treatmentGroup.id } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(treatmentGroup.name) +
                                "\n            "
                            ),
                          ]
                        )
                      }
                    ),
                  ],
                  2
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "input", attrs: { type: "select" } }, [
              _c("label", [
                _c("span", [_vm._v("Select treatmentgroup to")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.copyDispensingScheduleToTreatmentGroupId,
                        expression: "copyDispensingScheduleToTreatmentGroupId",
                      },
                    ],
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.copyDispensingScheduleToTreatmentGroupId = $event
                          .target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c(
                      "option",
                      { attrs: { value: "", disabled: "", selected: "" } },
                      [_vm._v("Select treatment group")]
                    ),
                    _vm._v(" "),
                    _vm._l(
                      _vm.formValue.treatmentGroups,
                      function (treatmentGroup) {
                        return _c(
                          "option",
                          { domProps: { value: treatmentGroup.id } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(treatmentGroup.name) +
                                "\n            "
                            ),
                          ]
                        )
                      }
                    ),
                  ],
                  2
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "input", attrs: { type: "checkbox" } }, [
              _c("label", { staticClass: "radio" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.copyDispensingScheduleClearToGroup,
                      expression: "copyDispensingScheduleClearToGroup",
                    },
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(
                      _vm.copyDispensingScheduleClearToGroup
                    )
                      ? _vm._i(_vm.copyDispensingScheduleClearToGroup, null) >
                        -1
                      : _vm.copyDispensingScheduleClearToGroup,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.copyDispensingScheduleClearToGroup,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            (_vm.copyDispensingScheduleClearToGroup =
                              $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.copyDispensingScheduleClearToGroup = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.copyDispensingScheduleClearToGroup = $$c
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c("small", [_vm._v("Clear target schedule group")]),
              ]),
            ]),
            _vm._v(" "),
            _c("button", { staticClass: "right edit" }, [
              _vm._v("Copy dispensing schedules"),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }